import { Action } from "../../../action";
import { DefaultApi } from "../../../api";
import { getCatchError } from "../../../getCatchError";
import { urls } from "../../../urls";

const setPostCopyBalance = (params) => {
    return async (dispatch, getState) => {
        try {
            await DefaultApi({
                params,
                method: 'post',
                url: urls.POST_COPY_REPLENISHMENT
            });
            dispatch(Action.SetGetUserById(params.id));
        } catch (error) {
            getCatchError(error)
        }
    }
}

export {
    setPostCopyBalance as SetPostCopyBalance
}